import React, { useState, useEffect, useCallback } from "react";
import { Helmet } from "react-helmet";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Button from '@material-ui/core/Button';
import readXlsxFile from "read-excel-file";
import { useDispatch, useSelector } from "react-redux";
import theme from "../../theme";
import CommonButton from "../../components/button";
import { ThreeDotsLoading } from "../loading";
import CommonFormDropDown from "../formdropdown";
import InfoIcon from "@material-ui/icons/Info";
import { getAdminWithdrawalCategoriesAction, bulkUpdateEmployeesAction } from "../../containers/companyDashboard/action";

var fileDownloader, fileUploader;

const isString = new RegExp(/^[a-zA-Z\s]*$/g);
const isNumber = new RegExp(/((\d+)((\.\d{1,2})?))$/g);
const isEmail = new RegExp(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i);

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "30px 0px",
  },
  container: {
    width: "350px",
    backgroundColor: theme.colors.White,
    boxShadow: "0px 0px 10px #CFD9EA80",
    borderRadius: "15px",
    padding: "50px 60px",
  },
  title: {
    color: theme.colors.DodgerBlue,
    fontSize: "24px",
    fontFamily: theme.fontFamily.MARKPROBOLD,
    marginBottom: "20px",
  },
  subText: {
    color: theme.colors.Violet,
    fontSize: "18px",
    fontFamily: theme.fontFamily.MARKPRO,
    marginBottom: "10px",
  },
  fileContainer: {
    backgroundColor: theme.colors.Zumthor,
    padding: "5px 10px",
    top: "15px",
    position: "relative",
    borderRadius: "3px",
    wordBreak: "break-word",
  },
  fileName: {
    color: theme.colors.DodgerBlue,
    fontSize: "14px",
    fontFamily: theme.fontFamily.MARKPROMEDIUM,
  },
  crossIcon: { marginLeft: "8px", marginBottom: "-4px", cursor: "pointer" },
  bingoImage: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: "40px",
  },
  modalPaper: {
    position: "absolute",
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    position: 'absolute',
    width: 400,
    backgroundColor: '#fff',
    border: '2px solid #000',
    boxShadow: '5px 5px 15px rgba(0, 0, 0, 0.5)',
    padding: 20,
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },

}));
const info = {
  "Default": "Applies Company General Limits To Employees",
  "Level 1": "Applies 20 % Withdrawal Limit To Employees",
  "Level 2": "Applies 45 % Withdrawal Limit To Employees",
  "Level 3": "Applies 70 % Withdrawal Limit To Employees",
  "Level 4": "Applies 100 % Withdrawal Limit To Employees",
}

function BulkUpdateEmployees({ setBulkEmployees }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const companyDashboardReducer = useSelector((state) => state.companyDashboardReducer);
  const getAdminWithdrawalCategoriesActionMethod = React.useCallback(
    (filters) => (dispatch(getAdminWithdrawalCategoriesAction(filters))), [dispatch]);
  const bulkUpdateEmployeesActionMethod = useCallback(
    (data) => dispatch(bulkUpdateEmployeesAction(data)),
    [dispatch]
  );

  const [file, setFile] = useState(null);
  const [errors, setErrors] = useState([]);
  const [modalStyle] = useState(getModalStyle);
  const [openModal, setOpenModal] = useState(false);
  const [bulkUpdates, setBulkUpdates] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [level, setLevel] = useState({ label: "Default", value: "0" })
  const [limitCategories, setLimitCategories] = useState([]);
  const [validDataCount, setValidDataCount] = useState(0);


  const handleButtonClick = () => {
    setShowModal(true);
  };

  const handleConfirmUpload = () => {
    fileUploader.click();
    setShowModal(false);
  };

  const handleCancelUpload = () => {
    setShowModal(false);
  };

  useEffect(() => {
    getAdminWithdrawalCategoriesActionMethod({ history: true })
  }, [])

  useEffect(() => {
    const { bulkUpdateSuccess, error, withdrawalLimitCategories } = companyDashboardReducer;
    if (bulkUpdateSuccess) {
      if (bulkUpdateSuccess.errors && bulkUpdateSuccess.errors.length) {
        setErrors(bulkUpdateSuccess.errors);
      } else {
        setBulkUpdates(bulkUpdateSuccess.data || bulkUpdateSuccess);
        setOpenModal(true);
      }
    }

    if (error) {
      setErrors(Array.isArray(error) ? error : [error]);
      if (file) setFile(null);
    } else if (!bulkUpdateSuccess) {
      setErrors([]);
    }
    if (Array.isArray(withdrawalLimitCategories?.data)) {
      let arr = []
      withdrawalLimitCategories.data.forEach((value) => {
        arr.push({ label: value.name, value: value.limit })
        info[value.name] = value.description
      })
      setLimitCategories(arr);
    }
  }, [companyDashboardReducer, file]);

  useEffect(() => {
    if (errors.length) {
      const ele = document.getElementsByClassName("error-container");
      if (ele.length) ele[0].scrollIntoView(false);
    }
  }, [errors]);

  const handleFileUpload = async (uploadedFile) => {
    try {
      const rows = await readXlsxFile(uploadedFile);
      const headers = rows[0]; // First Row Being The Header
      const data = rows.slice(1); // Remove the header, the remaining rows are the data

      let errorMessageArray = [];
      const formattedData = [];

      if (rows && rows.length > 1) {
        for (let i = 0; i < data.length; i++) {
          const row = data[i];
          let entry = {};
          row.forEach((value, index) => {
            entry[headers[index]] = value;
          });
          entry["withdrawal_percent"] = level["value"] ? level["value"].toString() : level["value"];

          // Validate Email
          if (!entry["Email"] || !entry["Email"].toString().trim()) {
            if (errorMessageArray.indexOf("Email may not be blank.") < 0) {
              errorMessageArray.push("Email may not be blank.");
            }
          } else if (
            entry["Email"].toString().trim() &&
            !entry["Email"].toString().trim().match(isEmail) &&
            errorMessageArray.indexOf("Email should be in proper format.") < 0
          ) {
            errorMessageArray.push("Email should be in proper format.");
          }

          // Validate Employee ID
          if (!entry["Employee ID"] || !entry["Employee ID"].toString().trim()) {
            if (errorMessageArray.indexOf("Employee ID may not be blank.") < 0) {
              errorMessageArray.push("Employee ID may not be blank.");
            }
          }

          // Validate First Name
          if (!entry["First Name"] || !entry["First Name"].toString().trim()) {
            if (errorMessageArray.indexOf("First Name may not be blank.") < 0) {
              errorMessageArray.push("First Name may not be blank.");
            }
          } else if (
            entry["First Name"].toString().trim() &&
            entry["First Name"].toString().trim().length > 24 &&
            errorMessageArray.indexOf("Ensure First Name has no more than 24 characters.") < 0
          ) {
            errorMessageArray.push("Ensure First Name has no more than 24 characters.");
          } else if (
            entry["First Name"].toString().trim() &&
            !entry["First Name"].toString().trim().match(isString) &&
            errorMessageArray.indexOf("First Name should contain only letters and spaces. Numbers and special characters are not allowed.") < 0
          ) {
            errorMessageArray.push("First Name should contain only letters and spaces. Numbers and special characters are not allowed.");
          }

          // Validate Last Name
          if (!entry["Last Name"] || !entry["Last Name"].toString().trim()) {
            if (errorMessageArray.indexOf("Last Name may not be blank.") < 0) {
              errorMessageArray.push("Last Name may not be blank.");
            }
          } else if (
            entry["Last Name"].toString().trim() &&
            entry["Last Name"].toString().trim().length > 24 &&
            errorMessageArray.indexOf("Ensure Last Name has no more than 24 characters.") < 0
          ) {
            errorMessageArray.push("Ensure Last Name has no more than 24 characters.");
          } else if (
            entry["Last Name"].toString().trim() &&
            !entry["Last Name"].toString().trim().match(isString) &&
            errorMessageArray.indexOf("Last Name should contain only letters and spaces. Numbers and special characters are not allowed.") < 0
          ) {
            errorMessageArray.push("Last Name should contain only letters and spaces. Numbers and special characters are not allowed.");
          }

          // Validate Position
          if (!entry["Position"] || !entry["Position"].toString().trim()) {
            if (errorMessageArray.indexOf("Position may not be blank.") < 0) {
              errorMessageArray.push("Position may not be blank.");
            }
          } else if (
            entry["Position"].toString().trim() &&
            entry["Position"].toString().trim().length > 24 &&
            errorMessageArray.indexOf("Ensure Position has no more than 24 characters.") < 0
          ) {
            errorMessageArray.push("Ensure Position has no more than 24 characters.");
          } else if (
            entry["Position"].toString().trim() &&
            !entry["Position"].toString().trim().match(isString) &&
            errorMessageArray.indexOf("Position should contain only letters and spaces. Numbers and special characters are not allowed.") < 0
          ) {
            errorMessageArray.push("Position should contain only letters and spaces. Numbers and special characters are not allowed.");
          }

          // Validate Salary
          if (!entry["Salary"] && entry["Salary"] !== 0) {
            if (errorMessageArray.indexOf("Salary may not be blank.") < 0) {
              errorMessageArray.push("Salary may not be blank.");
            }
          } else if (
            entry["Salary"] !== null &&
            entry["Salary"] !== undefined &&
            entry["Salary"] !== "" &&
            !entry["Salary"].toString().match(isNumber) &&
            errorMessageArray.indexOf("Salary should contain only numbers and decimal point. Letters and special characters (except decimal point) are not allowed.") < 0
          ) {
            errorMessageArray.push("Salary should contain only numbers and decimal point. Letters and special characters (except decimal point) are not allowed.");
          }

          // Validate Gross Salary
          if (!entry["Gross Salary"] && entry["Gross Salary"] !== 0) {
            if (errorMessageArray.indexOf("Gross Salary may not be blank.") < 0) {
              errorMessageArray.push("Gross Salary may not be blank.");
            }
          } else if (
            entry["Gross Salary"] !== null &&
            entry["Gross Salary"] !== undefined &&
            entry["Gross Salary"] !== "" &&
            !entry["Gross Salary"].toString().match(isNumber) &&
            errorMessageArray.indexOf("Gross Salary should contain only numbers and decimal point. Letters and special characters (except decimal point) are not allowed.") < 0
          ) {
            errorMessageArray.push("Gross Salary should contain only numbers and decimal point. Letters and special characters (except decimal point) are not allowed.");
          }

          formattedData.push(entry);
        }
      } else {
        errorMessageArray.push("No data found.");
      }

      if (errorMessageArray.length > 0) {
        setErrors(errorMessageArray);
        setFile(null);
        setValidDataCount(0);
      } else if (formattedData.length === 0) {
        setErrors(["No valid employee data found in the uploaded sheet."]);
        setFile(null);
        setValidDataCount(0);
      } else {
        setValidDataCount(formattedData.length);
        // Use Redux action instead of direct axios call
        bulkUpdateEmployeesActionMethod({ data: formattedData });
      }
    } catch (error) {
      setErrors([error.message || "An error occurred while processing the file."]);
      setFile(null);
    }
  };

  return (
    <div className={classes.root}>
      <Helmet>
        <title>{"Sanaam - Invite Employees"}</title>
        <meta property="og:title" content={"Sanaam - Invite Employees"} />
      </Helmet>
      <ThreeDotsLoading showLoader={companyDashboardReducer?.loading} />
      <div className={classes.container}>
        <div className={classes.title}>Bulk Employee Update</div>

        <div className={classes.subText}>
          Download our template to import your
          <br /> employees update to Sanaam
        </div>
        <div className={classes.subText}>

          <CommonFormDropDown
            label="Withdrawal Limit Level For Employees"
            placeholder={"Select Level"}
            // disabled={file ? true : false}
            options={[
              { label: "Default", value: "0" },
              ...limitCategories
            ]}
            value={level}
            onChange={(val) => {
              setLevel(val);
            }}
            isSearchable={false}
            error={false}
            helperText={""}
            isLoading={
              companyDashboardReducer?.loading
              || companyDashboardReducer?.withdrawalLimitCategoriesLoading
            }
          />
          <p
            style={{ fontSize: "0.875rem", color: "#666", flexDirection: "row", alignItems: "center", display: "flex" }}
          >
            <InfoIcon className={classes.infoIco} /> {info[level.label]}
          </p>
        </div>
        <div style={{ marginBottom: "40px" }}>
          <CommonButton
            stylevariant="secondary2"
            type="button"
            text={"Download Template"}
            onClick={() => {
              fileDownloader.click();
            }}
            icon={"/images/download.png"}
          />
          <a
            ref={(ref) => (fileDownloader = ref)}
            href={"/Bulk template list.xlsx"}
            download={`Bulk template list`}
            style={{ display: "none" }}
          >
            download
          </a>
        </div>
        <div className={classes.subText}>
          After downloading and filling our
          <br /> template please upload it here
        </div>
        <div style={{ marginBottom: "40px" }}>
          <CommonButton
            stylevariant="secondary2"
            type="button"
            text={"Upload Employee Sheets"}
            onClick={handleButtonClick}
            icon={"/images/upload.png"}
          />
          <Modal open={showModal} onClose={handleCancelUpload} className={classes.modal}>
            <div className={classes.paper}>
              <p>This action cannot be revoked. Are you sure you want to proceed?</p>
              <div className={classes.buttonContainer}>
                <Button variant="contained" style={{ backgroundColor: '#3E83FA' }} onClick={handleConfirmUpload}>Yes, Proceed</Button>
                <Button variant="contained" style={{ backgroundColor: '#FF3B59' }} onClick={handleCancelUpload}>Cancel</Button>
              </div>
            </div>
          </Modal>
          <input
            type="file"
            ref={(ref) => (fileUploader = ref)}
            style={{ display: "none" }}
            onClick={(event) => { event.target.value = null; }}
            onChange={(e) => {
              const selectedFile = e.target.files[0];
              setFile(selectedFile);
              setValidDataCount(0);
              setErrors([]);
            }}
            accept=".xlsx"
          />
          {file?.name && (
            <span className={classes.fileContainer}>
              <span className={classes.fileName}>{file.name}</span>
              <img
                src={"/images/cross.png"}
                alt="cross"
                className={classes.crossIcon}
                onClick={() => setFile(null)}
              />
            </span>
          )}
          {errors.length ? (
            <div className={"error-container"} style={{ marginTop: "4px" }}>
              <div>
                You have the following errors, please fix them and re-upload the
                sheet again.
              </div>
              <br />
              <ol>
                {errors.map((each, index) => (
                  <li key={index}>{each}</li>
                ))}
              </ol>
            </div>
          ) : null}
          {validDataCount === 0 && file?.name && !errors.length ? (
            <div className={"error-container"} style={{ marginTop: "4px" }}>
              <div>
                No valid employee data found in the uploaded sheet.
              </div>
            </div>
          ) : null}
        </div>

        <div style={{ marginTop: "70px" }}>
          <CommonButton
            type="button"
            text={"Submit"}
            stylevariant="secondary1"
            disabled={!file?.name || validDataCount === 0}
            onClick={() => {
              if (file) {
                handleFileUpload(file); // Trigger file processing and upload
              }
            }}
          />
        </div>
      </div>
      <Modal
        open={openModal}
        onClose={() => {
          setOpenModal(false);
          setBulkEmployees(false);
          setFile(null);
        }}
      >
        <div style={modalStyle} className={classes.modalPaper}>
          <div className={classes.container}>
            <div className={classes.bingoImage}>
              <img src={"/images/success_bingo.svg"} alt="success_bingo" />
            </div>
            <div className={classes.subText} style={{ textAlign: "center" }}>
              Updated successful!
            </div>
            <div style={{ marginTop: "70px" }}>
              <CommonButton
                type="button"
                text={"Done"}
                stylevariant="secondary1"
                onClick={() => {
                  setOpenModal(false);
                  setBulkEmployees(false);
                  setFile(null);
                }}
              />
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default BulkUpdateEmployees;
